<script context="module">
	import { z } from "zod";
	export const name = "Feed (rânduri)";
	export const CustomFields = z.object({
		title: z.string().optional(),
		more_url: z.string().optional(),
		compact: z.boolean().optional(),
	});
</script>

<script>
	// flat list of feed rows; forces the `row` item layout regardless of content_layout
	import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	$: items = (data && data.content && data.content.items) || [];
	$: cf = (data && data.custom_fields) || {};
	$: rowFields = { ...((data && data.content_custom_fields) || {}), compact: !!cf.compact };
</script>

<section class="af-feed af-panel">
	{#if cf.title}
		<h2 class="af-heading af-feed__heading">
			{#if cf.more_url}<a href={cf.more_url}>{cf.title} <span aria-hidden="true">→</span></a>{:else}{cf.title}{/if}
		</h2>
	{/if}
	<div class="af-feed__list" role="list">
		{#each items as item, index (item.id || index)}
			<div role="listitem" class="af-feed__item">
				<ContentItem data={{ content: item, layout: "row", custom_fields: rowFields }} indexInContainer={[index, items.length]} />
			</div>
		{/each}
	</div>
</section>

<style lang="scss">
	/* flat module on a sunk panel: hairlines only, no card radius on rows */
	.af-feed {
		width: 100%;
		grid-column: 1 / -1;
		padding: var(--af-space-4);
		background: var(--af-surface-sunk);
		border-radius: var(--af-radius-card);
	}

	.af-feed__heading a:hover {
		color: var(--af-brand);
	}

	.af-feed__list {
		display: flex;
		flex-direction: column;
	}

	@media (min-width: 768px) {
		.af-feed {
			padding: var(--af-space-4) var(--af-space-6) var(--af-space-2);
		}
	}

	.af-feed__item:last-child :global(.af-row) {
		border-bottom: 0;
	}

	.af-feed__item:not(:last-child) :global(.af-row) {
		border-bottom: 1px solid var(--af-hairline);
	}
</style>
